import styled from 'styled-components';

const AppWrapper = styled.div`
`;

export default AppWrapper;
